// extracted by mini-css-extract-plugin
module.exports = {"root":"AllTenantDocumentsModal_root__12cyU"};